

















import { defineComponent } from "@vue/composition-api";
import TagChip from "@c/atoms/tag/TagChip.vue";

export default defineComponent({
  name: "TagsInCard",

  components: {
    TagChip
  },

  props: {
    tags: Array
  },

  setup() {
    return {};
  }
});
